import React, { useEffect, useState, useContext, useMemo } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, TextField } from '@material-ui/core';
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { i18n } from '../../translate/i18n';
import { AuthContext } from "../../context/Auth/AuthContext";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";
import { Section } from "../../components/ui";
import { buildOptions } from "./ChartsUser";

const useStyles = makeStyles((theme) => {
    const t = getTokens(theme.palette.type, theme.palette.primary.main);
    return {
        root: {
            height: "100%",
            boxSizing: "border-box",
        },
        count: {
            fontWeight: 500,
            color: t.textSecondary,
            marginLeft: 6,
        },
        range: {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
        },
        rangeSep: {
            fontSize: 13,
            color: t.textMuted,
        },
        picker: {
            width: 150,
            [theme.breakpoints.down("xs")]: { flex: "1 1 120px", width: "auto" },
        },
    };
});

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const ChartsDate = () => {
    const classes = useStyles();
    const theme = useTheme();
    const t = useMemo(
        () => getTokens(theme.palette.type, theme.palette.primary.main),
        [theme.palette.type, theme.palette.primary.main]
    );
    const options = useMemo(() => buildOptions(t), [t]);
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    useEffect(() => {
        if (companyId) {
            handleGetTicketsInformation();
        }
    }, [companyId]);

    const dataCharts = {

        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data)),
        datasets: [
            {
                // label: 'Dataset 1',
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
                    return item.total
                }),
                backgroundColor: t.tint.strong,
                hoverBackgroundColor: t.brand,
                borderColor: t.brand,
                borderWidth: { top: 2, left: 0, right: 0, bottom: 0 },
                borderRadius: 6,
                maxBarThickness: 40,
            },
        ],
    };

    const handleGetTicketsInformation = async () => {
        try {
            const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
            setTicketsData(data);
        } catch (error) {
            toast.error('Erro ao buscar informações dos tickets');
        }
    }

    const rangePicker = (value, onChange, label) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
            <DatePicker
                value={value}
                onChange={onChange}
                renderInput={(params) => (
                    <TextField
                        size="small"
                        variant="outlined"
                        {...params}
                        inputProps={{ ...params.inputProps, "aria-label": label }}
                        className={classes.picker}
                    />
                )}
            />
        </LocalizationProvider>
    );

    return (
        <Section
            className={classes.root}
            title={(
                <>
                    {i18n.t("dashboard.users.totalAttendances")}
                    <span className={classes.count}>({ticketsData?.count})</span>
                </>
            )}
            actions={
                <div className={classes.range}>
                    {rangePicker(initialDate, (newValue) => { setInitialDate(newValue) }, i18n.t("dashboard.date.initialDate"))}
                    <span className={classes.rangeSep}>até</span>
                    {rangePicker(finalDate, (newValue) => { setFinalDate(newValue) }, i18n.t("dashboard.date.finalDate"))}
                    <Button onClick={handleGetTicketsInformation} variant="outlined">Filtrar</Button>
                </div>
            }
        >
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
        </Section>
    );
}
